import React from "react";
import { StaggerGroup, StaggerItem } from "@/components/Reveal";
import { SectionHeading } from "@/components/sections/SectionHeading";
import { DIASPORA } from "@/data/content";

export const Diaspora = () => {
  return (
    <section id="diaspora" data-testid="diaspora" className="relative bg-charcoal-deep py-24 sm:py-32">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-1/2 top-1/2 h-[500px] w-[500px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-gold/8 blur-[130px]" />
      </div>
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.22em] text-gold">
            <span className="h-px w-6 bg-gold" /> The Indian world
          </span>
          <h2 className="mt-4 font-serif text-4xl font-light leading-[1.08] tracking-tight text-ivory sm:text-5xl">
            One gold vault, <span className="italic text-gold-gradient">every timezone</span>
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-ivory/60">
            From London to Los Angeles, Dubai to Sydney — Shreedhan keeps 32 million diaspora
            Indians connected to gold back home.
          </p>
        </div>

        <StaggerGroup className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" stagger={0.1}>
          {DIASPORA.map((d) => (
            <StaggerItem key={d.country}>
              <div className="group h-full rounded-3xl border border-white/10 bg-white/[0.05] p-7 backdrop-blur-md transition-all duration-300 hover:-translate-y-1.5 hover:border-gold/40 hover:bg-white/[0.08]">
                <span className="text-4xl">{d.flag}</span>
                <h3 className="mt-4 font-serif text-xl text-ivory">{d.country}</h3>
                <p className="mt-2 text-sm leading-relaxed text-ivory/60">{d.line}</p>
              </div>
            </StaggerItem>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
};
